import { Validator } from '@vista-digital/validator';
import { seatValidator } from '../seats';
import { translatableValidator } from '../translations';
/**
 * Note: The min value is set to -1 and the max value is set to 101 due to incorrect data from the API.
 * It is possible for a top value to be a negative value e.g. -0.03 or the height + top of an area to be larger than 100 by a fractional number e.g. 100.08.
 * This is a temporary solution until data can be fixed at the source, it does not fix any rendering issue due to bad data.
 */
export const seatLayoutGridUnitValidator = Validator.number({ min: -1, max: 101 });
export const seatLayoutBoundaryValidator = Validator.object({
    left: seatLayoutGridUnitValidator,
    right: seatLayoutGridUnitValidator,
    top: seatLayoutGridUnitValidator
});
export const areaBoundaryValidator = Validator.object({
    left: seatLayoutGridUnitValidator,
    top: seatLayoutGridUnitValidator,
    right: seatLayoutGridUnitValidator,
    bottom: seatLayoutGridUnitValidator
});
export const areaCategoryValidator = Validator.object({
    id: Validator.nonEmptyString,
    name: translatableValidator,
    hopk: Validator.optional(Validator.nonEmptyString),
    isAllocatedSeating: Validator.boolean(),
    isInSeatItemDeliveryAvailable: Validator.boolean()
});
export const showtimeAreaCategoryValidator = Validator.object({
    areaCategoryId: Validator.nonEmptyString,
    isAllocatedSeating: Validator.boolean()
});
export const rowValidator = Validator.object({
    number: Validator.number({ min: 1 }),
    label: Validator.nonEmptyString,
    seats: Validator.array({ items: seatValidator })
});
export const areaValidator = Validator.object({
    number: Validator.number({ min: 1 }),
    areaCategoryId: Validator.nonEmptyString,
    name: translatableValidator,
    boundary: areaBoundaryValidator,
    columnCount: Validator.number({ min: 0 }),
    rowCount: Validator.number({ min: 0 }),
    rows: Validator.array({ items: rowValidator })
});
export const screenValidator = Validator.object({
    id: Validator.nonEmptyString,
    name: translatableValidator
});
export const screenBoundaryValidator = Validator.object({
    left: seatLayoutGridUnitValidator,
    right: seatLayoutGridUnitValidator
});
export const seatLayoutValidator = Validator.object({
    id: Validator.nonEmptyString,
    screenId: Validator.nonEmptyString,
    boundary: seatLayoutBoundaryValidator,
    screenBoundary: screenBoundaryValidator,
    areas: Validator.array({ items: areaValidator })
});
//# sourceMappingURL=validators.js.map